import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import MediaCard from "./MediaCard.js"

const TrendingSong = () => {
  const data = useStaticQuery(graphql`
    query {
      allSongListJson {
        edges {
          node {
            id
            title
            duration
            link
            whatsappLink
            imageRelativePath
          }
        }
      }
      allFile(filter: { relativeDirectory: { eq: "songs" } }) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(width: 144, height: 108, placeholder: BLURRED)
          }
        }
      }
    }
  `)

  const songList = data.allSongListJson.edges.map(({ node }) => {
    const matchedImage = data.allFile.nodes.find(
      file => file.relativePath === node.imageRelativePath
    )

    return {
      id: node.id,
      title: node.title,
      duration: node.duration,
      link: node.link,
      whatsappLink: node.whatsappLink,
      imageSrc: matchedImage ? matchedImage.childImageSharp.gatsbyImageData : null,
    }
  })

  return (
    <>
      <h2 className="mb-[25px] flex items-center justify-center gap-3 text-center text-2xl font-bold">
        Now Trending
      </h2>
      <div className="-mx-6 grid grid-cols-1 gap-6 sm:mx-0">
        {songList.map((item, index) => (
          <MediaCard
            key={`${item.id || index}-${item.title}`}
            imageSrc={item.imageSrc}
            alt={item.title}
            title={item.title}
            duration={item.duration}
            whatsappLink={item.whatsappLink}
            link={item.link}
          />
        ))}
      </div>
    </>
  )
}

export default TrendingSong
